<template lang="pug">
	#app
		#nav
			router-link(
				to="/"
			) Home
			span {{ ' | ' }}
			router-link(
				to="/about"
			) About
		router-view()
</template>

<script>
export default {
	name: "Main",
	components: {},
	data: function() {
		return {}
	}
}
</script>

<style lang="scss" scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
}

#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: black;
    &.router-link-exact-active {
      color: grey;
    }
  }
}
</style>
